import React from 'react';
import TableColumnTitle from '../../../../../components/_table/TableColumnTitle';

/**
 *  태그에 연결된 아이템 컬림
 */
export const columns = () => {
  return [
    {
      title: <TableColumnTitle title={'상품 카테고리 ID'} />,
      dataIndex: 'productCategoryId',
    },
    {
      title: <TableColumnTitle title={'상품 카테고리명'} />,
      dataIndex: 'productCategoryName',
    },
  ];
};
